module.exports = __webpack_public_path__ + "static/img/vip.d702847c.png";